jQuery(function ($) {
  $('.header-search-toggle').interact(() => {
    $searchAppInput = $('#search-react .search-input');
    if ($searchAppInput.length) {
      $searchAppInput.focus();
    }
  });
});
